import React, {useState} from 'react';

import {FormControlGroup} from 'app/general/forms';
import {useAddBlock, useUpdateBlock} from 'app/kbs/api';
import {gt} from 'app/utils/i18n';

import type {KBBlockSerializedType} from 'sweet-types';

interface Props {
  block: KBBlockSerializedType;
  label: string;
  knowledgebase: string;
}

export const EditKBBlock = ({block, label, knowledgebase}: Props) => {
  const [value, setValue] = useState<string>(block.content);
  const [addBlock] = useAddBlock();
  const [updateBlock] = useUpdateBlock();

  const onChange = (content: string) => {
    if (block.url === '') {
      addBlock({name: block.name, content, knowledgebase});
    } else {
      updateBlock({content, url: block.url});
    }
  };

  return (
    <FormControlGroup field={block.name} className="mb-4">
      <label htmlFor={`block-${block.name}`}>{label}</label>
      <div className="input-group">
        <input
          type="text"
          value={value}
          className="form-control"
          id={`block-${block.name}`}
          onChange={(e) => setValue(e.target.value)}
        />
        <div className="input-group-append">
          <button
            onClick={(e) => {
              e.preventDefault();
              onChange(value);
            }}
            className="btn btn-primary"
          >
            {gt('OK')}
          </button>
        </div>
      </div>
    </FormControlGroup>
  );
};
